// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jw-popover[data-v-968113ba]{position:absolute;background:#060d17;border-radius:4px;overflow-y:auto;display:flex;flex-direction:column}.jw-popover__body[data-v-968113ba]{overflow-y:auto;flex:1;min-height:0}", ""]);
// Exports
module.exports = exports;
